export const MEDIA_QUERY_TABLET = '(max-width: 992px)'
export const MEDIA_QUERY_MOBILE = '(max-width: 576px)'
